import AddSlot from "../components/AddSlot";
import Breadcrumb from "../components/Breadcrumb";

const AddSlotPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="All Clients" />

      {/*All Clients Layer*/}
      <AddSlot />
    </>
  );
};

export default AddSlotPage;
